import { Card, Stack } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useCacheQuery } from 'gossamer-front-end';
import { ConvoUserView, ConvoUserViewRow } from 'cb-model';
import { CreateForumConvoModal } from '../convo/CreateForumConvoModal';
import { CreateUserConvoModal } from '../convo/CreateUserConvoModal';
import classes from './EventConvosCard.module.css';

interface EventConvosCardProps {
  isBooked: boolean;
  eventId: number;
  eventTitle: string;
  eventInstitutionId: number;
  mainHostUserId: string;
}

export const EventConvosCard = (props: EventConvosCardProps): React.JSX.Element => {
  const convoQuery = useCacheQuery(
    ConvoUserView,
    {
      where: {
        and: [
          { fieldId: 'forum_type', operator: 'eq', value: 'Event' },
          { fieldId: 'forum_key', operator: 'eq', value: String(props.eventId) },
        ],
      },
      limit: 200,
    },
    !props.isBooked,
  );

  const renderConvo = (convo: ConvoUserViewRow) => (
    <li key={convo.id} className={classes.Convo}>
      {convo.latest_message_id > convo.latest_read_message_id && <span>•</span>}
      🗨&nbsp;
      <u>
        <NavLink to={`/website/inbox/${convo.id}`}>{convo.subject_text}</NavLink>
      </u>
      &nbsp;
    </li>
  );

  if (!props.isBooked) {
    return (
      <Card>
        <Card.Header>Conversations</Card.Header>
        <Card.Body>Event conversations are available from your inbox after booking.</Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header>Conversations</Card.Header>
      <Card.Body>
        <p>Message threads related to this event</p>
        {convoQuery.isFetching && <div>Loading...</div>}
        {(convoQuery.data?.length ?? 0) > 0 && <ul>{(convoQuery.data || []).map(renderConvo)}</ul>}
        {convoQuery.data?.length === 0 && <div>None</div>}
        <Stack direction="horizontal" gap={3} className="mt-3">
          <CreateForumConvoModal
            buttonLabel="Create a new shared conversation"
            forumType="Event"
            forumKey={String(props.eventId)}
            institutionId={props.eventInstitutionId}
          />
          <CreateUserConvoModal
            buttonLabel="Message event host privately"
            recipientUserId={props.mainHostUserId}
            subjectText={`Private message for host of event '${props.eventTitle}'`}
          />
        </Stack>
      </Card.Body>
    </Card>
  );
};
